import { useState, useEffect } from "react";
import { useI18n } from "@/lib/i18n";
import { Cookie, X } from "lucide-react";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const { lang } = useI18n();

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem("cookie_consent", "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[60] animate-fade-in">
      <div className="bg-navy border border-cream/15 rounded-2xl p-5 shadow-2xl backdrop-blur-xl">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-cream/10 rounded-xl flex items-center justify-center shrink-0 mt-0.5">
            <Cookie className="text-cream" size={20} />
          </div>
          <div className="flex-1">
            <h3 className={`text-cream font-bold text-sm mb-1 ${lang === "en" ? "font-houstiq" : ""}`}>
              {lang === "ar" ? "ملفات تعريف الارتباط" : "Cookie Notice"}
            </h3>
            <p className="text-cream/50 text-xs leading-relaxed">
              {lang === "ar"
                ? "نستخدم ملفات تعريف الارتباط لتحسين تجربتك وقياس أداء الموقع. بمتابعة التصفح، فإنك توافق على سياسة الخصوصية."
                : "We use cookies to enhance your experience and measure site performance. By continuing to browse, you agree to our privacy policy."}
            </p>
            <div className="flex items-center gap-2 mt-3">
              <button
                onClick={accept}
                className="bg-cream text-navy font-bold px-4 py-2 rounded-lg text-xs hover:opacity-90 transition-opacity"
              >
                {lang === "ar" ? "موافق" : "Accept"}
              </button>
              <button
                onClick={decline}
                className="bg-cream/10 text-cream/70 font-medium px-4 py-2 rounded-lg text-xs hover:bg-cream/15 transition-colors"
              >
                {lang === "ar" ? "رفض" : "Decline"}
              </button>
              <a
                href="/privacy"
                className="text-cream/40 text-xs hover:text-cream/60 transition-colors mr-auto"
              >
                {lang === "ar" ? "سياسة الخصوصية" : "Privacy Policy"}
              </a>
            </div>
          </div>
          <button onClick={decline} className="text-cream/30 hover:text-cream/60 transition-colors">
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
